// File: cgp-sidenav.component.ts
// Author: Joseph M Diaz
// Date: 5/10/2017
// Desc: Sidenav component. Items are loaded fromt he config file.
// Other Contributors:

import { Component, Input } from '@angular/core';

import { config } from '../../../config/config';
import { CgpSidenavService } from './cgp-sidenav.service';

@Component({
    selector: 'cgp-sidenav',
    templateUrl: './cgp-sidenav.template.html',
    styleUrls: ['./cgp-sidenav.style.scss']
})
export class CgpSidenavComponent {
    @Input('panelbar-hidden') panelbarHidden;
    items;

    constructor(public cgpSidenavService: CgpSidenavService) {
        this.cgpSidenavService.cgpSidenavComponent = this;
        this.items = config.navItems;
        this.items[0].isFirstItem = true;
        this.items[this.items.length - 1].isLastItem = true;
    }
}